import {Record} from "./Record";


export class Page extends Record {
    resizer_key:string = "";
    title:string = "";
    caption:string = "";
    name:string = "";
    user_display_name:string = "";
    price:string = "";
    subdomain:string = "";
    comment_count = 0;

    imageUrl(size:string = "medium"): string {
        return `${Constants.get('RESIZER_URL')}/${this.resizer_key}/${size}.${Constants.get('IMAGE_FORMAT')}`;
    }

    url(): string {
        const port = Constants.get('PORT_OVERRIDE') ? `:${Constants.get('PORT_OVERRIDE')}` : "";
        return `${Constants.get('PROTOCOL')}://${this.subdomain}.${Constants.get('HOST_BASE')}${port}`
    }
}
